import React from 'react'
import makeStyles from "@material-ui/core/styles/makeStyles";
import { MessageServices } from 'lib/services/api/messaging/message_services';
import { useContext, useEffect, useState } from 'react';
import { WorkshopContext } from 'views/Operations/Workshop/WorkshopContext/WorkshopContext';
import { IconButton } from '@material-ui/core';
import { getOrganisationId } from 'lib/utils/common_utils';

const useStyles = makeStyles((theme) => ({
    badge: {
        width: '24px',
        height: '24px',
        borderRadius: '14px',
        // backgroundColor: 'red',
        fontSize: '16px',
        marginTop: '-1px',
        marginLeft: '-15px',
        color: '#fff'
    },
}));

function MessageCount(props) {
    const {name} = props;
    const classes = useStyles()
    const { messageTotalCount, setMessagetotalCount , smsTotalCount, setSMSTotalCount ,  messageTotalCountColor, 
        setMessagetotalCountColor,
        smsTotalCountColor, 
        setSMSTotalCountColor } = useContext(WorkshopContext)
    //message bagde
    let userDetails = JSON.parse(sessionStorage.getItem("user"));

    const getTotalUnReadCount = async () => {
        if (!userDetails?.id) return;
        const params = {
            user_id: userDetails?.id,
            organisation_id : getOrganisationId(),
        }
        MessageServices.getTotalUnReadCount(params).then((res) => {
            const details = res?.data || {};
            // Messages badge values 
            let total = parseInt(details?.message_count || 0) + parseInt(details?.read_sign_count || 0) + parseInt(details?.sms_item_count || 0)
            setMessagetotalCount(total)
            setMessagetotalCountColor(details?.read_sign_color === "red" || details?.message_color === "red" || details?.sms_item_colour==="red" ? "#FF0202" : "#FFB300")
           
            // SMS Badge values
            setSMSTotalCount(details?.sms?.sms_item_count || 0);    
            setSMSTotalCountColor(details?.sms?.sms_item_colour === "red" ? "#FF0202" : "#FFB300")
        }).catch(() => {

        })
    }
    // console.log("messagecount======", messageTotalCount)
    useEffect(() => {
        const timeout = setTimeout(() => {
            getTotalUnReadCount()
        }, 0)
        return () => {
            clearTimeout(timeout)
        }
    }, [userDetails?.id])
    const totalCount = name === "SMS" ? smsTotalCount : messageTotalCount 
    const totalColor = name === "SMS" ? smsTotalCountColor : messageTotalCountColor;
    return (
        <>
            {(totalCount > 0 && totalColor)  ? <span>
                <IconButton size="small" style={{
                    backgroundColor: totalColor 
                }} className={classes.badge}>{totalCount}</IconButton></span> : ''}

        </>
    )
}

export default MessageCount